import { render, staticRenderFns } from "./BigData.vue?vue&type=template&id=88c51258&scoped=true&"
import script from "./BigData.vue?vue&type=script&lang=js&"
export * from "./BigData.vue?vue&type=script&lang=js&"
import style0 from "./BigData.vue?vue&type=style&index=0&id=88c51258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c51258",
  null
  
)

export default component.exports